export default __webpack_public_path__ + "static/media/loginGirl.9ab22b71.svg";